export const GREY = "#C4C7D4";

export const tenureYears = (doj) => {
  if (!doj) return null;
  const t = new Date(doj).getTime();
  if (isNaN(t)) return null;
  return (Date.now() - t) / (365.25 * 24 * 3600 * 1000);
};

export const tenureLabel = (doj) => {
  const y = tenureYears(doj);
  if (y == null) return "—";
  const months = Math.floor(y * 12);
  const yrs = Math.floor(months / 12);
  const mos = months % 12;
  if (yrs === 0) return `${mos} mo${mos === 1 ? "" : "s"}`;
  return `${yrs} yr${yrs === 1 ? "" : "s"} ${mos} mo${mos === 1 ? "" : "s"}`;
};

export const bandFor = (doj, bands) => {
  const y = tenureYears(doj);
  if (y == null || !bands?.length) return null;
  for (const b of bands) {
    if (b.max_years == null || y < b.max_years) return b;
  }
  return bands[bands.length - 1];
};

export const bandColor = (doj, colorConfig) => {
  if (!colorConfig?.enabled) return null;
  const b = bandFor(doj, colorConfig.bands);
  return b ? b.color : GREY;
};

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

export const photoOf = (emp) => {
  if (emp?.photo_file) return `${process.env.REACT_APP_BACKEND_URL}${emp.photo_file}`;
  return emp?.photo_url || null;
};

export const fmtDate = (d, format = "DD-MM-YYYY") => {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  if (format === "YYYY-MM-DD") return `${yyyy}-${mm}-${dd}`;
  if (format === "MM/DD/YYYY") return `${mm}/${dd}/${yyyy}`;
  return `${dd}-${mm}-${yyyy}`;
};

export const relTime = (iso) => {
  if (!iso) return "—";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const ROLE_COLORS = {
  super_admin: { bg: "#A25DDC1c", text: "#A25DDC", label: "Super Admin" },
  admin: { bg: "#E2445C1c", text: "#E2445C", label: "Admin" },
  editor: { bg: "#FDAB3D24", text: "#c97a10", label: "Editor" },
  viewer: { bg: "#181B340d", text: "#676a82", label: "Viewer" },
};

export const CARD_FIELD_DEFS = [
  { key: "designation", label: "Designation" },
  { key: "department", label: "Department" },
  { key: "date_of_joining", label: "Date of Joining" },
  { key: "email", label: "Email" },
  { key: "location", label: "Location" },
  { key: "employment_type", label: "Employment Type" },
  { key: "linkedin_url", label: "LinkedIn URL" },
  { key: "highest_qualification", label: "Highest Qualification" },
];
